// src/tenantAdmin/tenantAdminApi.js
import { apiFetch } from '../auth/apiFetch.js';

const TENANT_ADMIN = '/api/v1/tenant-admin';

export async function listTenantUsers({ limit = 50, offset = 0, email } = {}) {
  const params = new URLSearchParams({ limit, offset });
  if (email) params.set('email', email);
  const res = await apiFetch(`${TENANT_ADMIN}/users?${params}`);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Failed to list users: ${res.status}`);
  }
  return res.json();
}

export async function createTenantUser({ email, password, role = 'editor' }) {
  const res = await apiFetch(`${TENANT_ADMIN}/users`, {
    method: 'POST',
    body: JSON.stringify({ email, password, role }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.message || `Failed to create user: ${res.status}`);
    err.status = res.status;
    err.code = body.error_code;
    throw err;
  }
  return res.json();
}

export async function attachTenantUser({ email, role = 'editor' }) {
  const res = await apiFetch(`${TENANT_ADMIN}/users/attach`, {
    method: 'POST',
    body: JSON.stringify({ email, role }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Failed to attach user: ${res.status}`);
  }
  return res.json();
}

export async function deactivateTenantUser(userId) {
  const res = await apiFetch(`${TENANT_ADMIN}/users/${userId}/deactivate`, { method: 'POST' });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.message || `Failed to deactivate: ${res.status}`);
    err.status = res.status;
    err.code = body.error_code;
    throw err;
  }
  return res.json();
}

export async function changeTenantUserRole(userId, role) {
  const res = await apiFetch(`${TENANT_ADMIN}/users/${userId}/role`, {
    method: 'PATCH',
    body: JSON.stringify({ role }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Failed to change role: ${res.status}`);
  }
  return res.json();
}

export async function removeTenantUser(userId) {
  const res = await apiFetch(`${TENANT_ADMIN}/users/${userId}`, { method: 'DELETE' });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Failed to remove user: ${res.status}`);
  }
  return res.json();
}
